var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":'附属项目',"visible":"","before-close":() => _vm.$emit('close'),"append-to-body":""}},[_c('div',{staticClass:"sub-projects-container info-window"},_vm._l((_vm.subProjects),function(project){return _c('div',{key:project.id,domProps:{"innerHTML":_vm._s(_vm.getHtmlInfoWindow(project))}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }